import { call, takeEvery, takeLatest, all } from 'redux-saga/effects';
import * as types from './types';
import * as api from './api';

import { findGenerator, getAllGenerator, updateGenerator } from 'helpers/resourceSagas';

export const find = findGenerator({
  resourceType: 'bypassedSubscriptions',
  endpoint: api.find,
});

export const fetchAll = getAllGenerator({
  resourceType: 'bypassedSubscriptions',
  endpoint: api.fetchAll,
  endpointArgs: (payload) => [ payload.userId ]
});

export const updatePlan = updateGenerator({
  resourceType: 'bypassedSubscriptions',
  endpoint: api.updatePlan,
  endpointArgs: (payload) => [ payload.id, payload.planId ]
});

export const update = updateGenerator({
  resourceType: 'bypassedSubscriptions',
  endpoint: api.update,
  endpointArgs: (payload) => [ payload.id, payload.fields ]
});

export function* watchFind() {
  yield takeEvery(types.FIND, find);
}

export function* watchFetchAll() {
  yield takeEvery(types.FETCH_ALL, fetchAll);
}

export function* watchUpdatePlan() {
  yield takeLatest(types.UPDATE_PLAN, updatePlan);
}

export function* watchUpdate() {
  yield takeLatest(types.UPDATE, update);
}

export function* watchBypassedSubscriptions() {
  yield all([
    call(watchFind),
    call(watchFetchAll),
    call(watchUpdatePlan),
    call(watchUpdate),
  ]);
}
